// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Courier Prime', 'Courier Prime Fallback'","fontStyle":"normal"},"className":"__className_87c02c"};